/**
 * useStoreMode — determines if this store template is an e-commerce store
 * or a catalog-only template (no purchasing, request-a-quote instead).
 *
 * The mode is persisted as a content key `__store-mode`.
 * Master templates set this key once, and it's copied to child templates
 * automatically when duplicated.
 *
 * Values:
 *   "ecommerce" (default) — full cart + purchase flow
 *   "catalog"             — no cart, "request a quote" instead
 */

import { useContentEditingSafe } from "./ContentEditingContext";

export type StoreMode = "ecommerce" | "catalog";

const STORE_MODE_KEY = "__store-mode";

export function useStoreMode(): StoreMode {
  const ctx = useContentEditingSafe();
  const raw = ctx?.getContent(STORE_MODE_KEY, "ecommerce") ?? "ecommerce";
  return raw === "catalog" ? "catalog" : "ecommerce";
}

/** Check if the current store is in catalog (quote-only) mode */
export function useIsCatalogMode(): boolean {
  return useStoreMode() === "catalog";
}

export { STORE_MODE_KEY };
